import React, { Component } from 'react';

import OrchestraMenu from '../../common/OrchestraMenu/OrchestraMenu';
import OrchestraHeader from '../../common/OrchestraHeader/OrchestraHeader';
import ScrollButton from '../../common/ScrollButton/ScrollButton';
import { isDesktopWidth } from './layoutConstants';

import { Pane } from 'evergreen-ui';

class OrchestraLayout extends Component {
    constructor(props) {
        super(props);
        this.scrollContainerRef = React.createRef();
        this.resizeTimeout = null;
        
        // Determine initial sidebar state based on screen width
        this.state = {
            isSidebarOpen: isDesktopWidth()
        };
    }

    componentDidMount() {
        // Add window resize listener with debouncing to handle responsive behavior
        this.handleResize = () => {
            // Clear existing timeout
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
            
            // Debounce resize handler to prevent excessive state updates
            this.resizeTimeout = setTimeout(() => {
                const isDesktop = isDesktopWidth();
                if (isDesktop && !this.state.isSidebarOpen) {
                    this.setState({ isSidebarOpen: true });
                } else if (!isDesktop && this.state.isSidebarOpen) {
                    this.setState({ isSidebarOpen: false });
                }
            }, 150);
        };
        
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        // Clean up resize listener and timeout
        if (this.handleResize) {
            window.removeEventListener('resize', this.handleResize);
        }
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
    }

    toggleSidebar = () => {
        this.setState(prevState => ({
            isSidebarOpen: !prevState.isSidebarOpen
        }));
    }

    render() {
        return (<>
                <OrchestraHeader onToggleSidebar={this.toggleSidebar} />
                <Pane display="flex">
                    <OrchestraMenu 
                        isOpen={this.state.isSidebarOpen} 
                        onClose={this.toggleSidebar}
                    />
                    <Pane
                        is="div"
                        ref={this.scrollContainerRef}
                        className="orchestra-content"
                        flexGrow="1"
                        maxHeight="calc(100vh - 60px)"
                        overflowY="auto"
                    >
                        {this.props.children}
                    </Pane>
                    <ScrollButton scrollContainerRef={this.scrollContainerRef} />
                </Pane>
            </>
        )
    }
}

export default OrchestraLayout;